import PRODUCTS from "./products.json"
export const getProductsBySection = (section) => {
  return PRODUCTS.filter((oneProduct) => {
    return oneProduct.section.includes(section);
  });
};